export default function QuickPromptChipGroup({
  c,
  title,
  prompts,
  onApply,
  onEdit,
  canDelete,
  quickPromptChipButtonStyle,
  titleSuffix = "",
  titleMarginTop = 0,
}) {
  return (
    <>
      <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: ".05em", textTransform: "uppercase", color: c.textSecondary, marginTop: titleMarginTop }}>
        {title}
      </div>
      <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
        {prompts.map((prompt) => (
          <div key={prompt.id} style={{ display: "inline-flex", alignItems: "center", border: `1px solid ${c.border}`, borderRadius: 999, background: c.bg, overflow: "hidden" }}>
            <button
              onClick={() => onApply(prompt)}
              style={quickPromptChipButtonStyle("main")}
              title={`${prompt.title || "Ohne Titel"}\n${prompt.text}${titleSuffix}`}
            >
              {prompt.title || "Ohne Titel"}
            </button>
            {canDelete && (
              <button
                onClick={() => onEdit(prompt)}
                style={quickPromptChipButtonStyle("edit")}
                title="Bearbeiten"
              >
                ✎
              </button>
            )}
          </div>
        ))}
      </div>
    </>
  );
}
